import React, { Component } from "react";
import Box from "@mui/material/Box";
import Drawer from "@mui/material/Drawer";
import Stack from "@mui/material/Stack";
import List from "@mui/material/List";
import Divider from "@mui/material/Divider";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import EmailIcon from "@mui/icons-material/Email";
import AccountCircleOutlinedIcon from "@mui/icons-material/AccountCircleOutlined";
import CardMembershipIcon from "@mui/icons-material/CardMembership";
import AccountBoxIcon from "@mui/icons-material/AccountBox";
import ContactPhoneIcon from "@mui/icons-material/ContactPhone";
import LogoutIcon from "@mui/icons-material/Logout";
import InstagramIcon from "@mui/icons-material/Instagram";
import TelegramIcon from "@mui/icons-material/Telegram";
import SystemUpdateIcon from "@mui/icons-material/SystemUpdate";

class RightMenu extends Component {
  render() {
    const {
      showActive,
      mobileNumber,
      NameFamily,
      toggleDrawer,
      handleComToShow,
    } = this.props;
    return (
      <Drawer
        anchor="left"
        sx={{ backgroundColor: "primary.main" }}
        open={showActive}
        onClose={toggleDrawer(false)}
      >
        <Box
          sx={{ width: 250 }}
          role="presentation"
          onClick={toggleDrawer(false)}
          onKeyDown={toggleDrawer(false)}
        >
          <Stack mt={7} justifyContent="center" alignItems="center" spacing={2}>
            <AccountCircleOutlinedIcon fontSize="large" />
            <strong>{NameFamily}</strong>
            <p>{mobileNumber}</p>
            <hr style={{ width: 200 }} />
            <List>
              {[
                {
                  text: "پروفایل",
                  icon: <AccountBoxIcon sx={{ color: "#fff" }} />,
                  compName: "userprofile",
                },
                {
                  text: "پیگیری‌ها",
                  icon: <CardMembershipIcon sx={{ color: "#fff" }} />,
                  compName: "peygiriha",
                },
                {
                  text: "صندوق پیام",
                  icon: <EmailIcon sx={{ color: "#fff" }} />,
                  compName: "message",
                },

                {
                  text: "تماس با ما",
                  icon: <ContactPhoneIcon sx={{ color: "#fff" }} />,
                  compName: "contact",
                },
                {
                  text: "خروج از حساب کاربری",
                  icon: <LogoutIcon sx={{ color: "#fff" }} />,
                  compName: "logout",
                },
              ].map((m, index) => (
                <ListItem key={index} disablePadding>
                  <ListItemButton onClick={() => handleComToShow(m.compName)}>
                    <ListItemIcon>{m.icon}</ListItemIcon>
                    <ListItemText primary={m.text} />
                  </ListItemButton>
                </ListItem>
              ))}
              <ListItem disablePadding>
                <ListItemButton
                  onClick={() => {
                    window.location.reload();
                  }}
                >
                  <ListItemIcon>
                    <SystemUpdateIcon />
                  </ListItemIcon>
                  <ListItemText primary="بروز رسانی" />
                </ListItemButton>
              </ListItem>
            </List>
            <Divider />
          </Stack>
          <hr style={{ width: 200 }} />
          <Stack
            mt={2}
            justifyContent="center"
            alignItems="center"
            direction="row"
            spacing={2}
            divider={<Divider orientation="vertical" flexItem />}
          >
            <a href="https://instagram.com/neginaluminium">
              <InstagramIcon sx={{ fontSize: 48, color: "#c5c5c5" }} />
            </a>
            <a href="https://t.me/neginaluminium">
              <TelegramIcon sx={{ fontSize: 48, color: "#c5c5c5" }} />
            </a>
          </Stack>
        </Box>
      </Drawer>
    );
  }
}

export default RightMenu;
